import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from "@angular/core";

import { InitService } from "@core/services/init-service";

import { DialogBoxTransmitterService } from "@theme/@confect/services/confect-dialog-box-transmitter.service";
import { HelpService } from "@theme/@confect/services/confect-help.service";

import { Subject, takeUntil } from "rxjs";

import { PageArticle } from "./models";

export interface HelpItem {
  key: string;
  display: string;
  action: string;
  extra?: any;
}

@Component({
  selector: "confect-help-guide",
  templateUrl: "./help-guide.component.html",
  standalone: false,
  styleUrls: ["./help-guide.component.scss"],
})
export class CHelpGuideComponent implements OnInit, OnDestroy {
  private dialogTransmitter = inject(DialogBoxTransmitterService);
  private init = inject(InitService);
  private helpService = inject(HelpService);

  unsubscribe$ = new Subject<any>();

  @Input({ required: true }) items: HelpItem[];
  @Input() articles: PageArticle[];
  @Input() boxTitle;
  @Input() unreadCount: number;
  @Input() inspiration: boolean = false;

  @ViewChild("box") box;

  showChat: boolean = false;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  activateAction(item: HelpItem, event?: MouseEvent) {
    switch (item.action) {
      case "transmit":
        this.dialogTransmitter.transmit({
          id: item.key,
          text: item.extra.text,
          event: event,
        });
    }
  }

  ngOnInit(): void {
    this.helpService.unreadObservable
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res) => {
          this.unreadCount = res;
        },
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  openLiveChat(e: MouseEvent) {
    this.showChat = true;
    this.init.getUnreadChanges();

    this.box.open(e);
  }

  openArticle(url: string): void {
    window.open(url, "_blank");
  }

  closeLiveChat(e: MouseEvent) {
    setTimeout(() => {
      this.showChat = false;
    });
  }

  open = (e: MouseEvent) => {
    if (this.box != null && this.box?.dialogRef != null) {
      return;
    }
    this.box?.open(e);
  };

  close = (e: MouseEvent) => {
    if (this.box != null && this.box?.dialogRef == null) {
      return;
    }
    this.box?.open(e);
  };
}
